const initialState = {
    productInterestOptions: [],
    productInterestOptionCount: 0,
    isReadingProductInterestOptions: false
}

export default initialState;
